import React, { useContext, useEffect, useState } from "react";
import { LocationsContext } from "../../context/LocationsContext";
import SearchSelect from "../common/SearchSelect";
import "./AddressFilter.css";

const AddressFilter = ({
  onChange,
  placeholderCountry,
  placeholderState,
  placeholderCity,
  placeholderSearch,
  allowedCountryCodes,
}) => {
  const { cities, states, countries, getCities, getStates, getCountries } =
    useContext(LocationsContext);

  const filteredCountries = Array.isArray(countries)
    ? allowedCountryCodes?.length
      ? countries.filter((c) => allowedCountryCodes.includes(c.iso2))
      : countries
    : countries;

  const [countryCode, setCountryCode] = useState(null);
  const [countryName, setCountryName] = useState("");
  const [stateCode, setStateCode] = useState(null);
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (countryCode) {
      getStates(countryCode);
    } else {
      setStateCode(null);
      setStateName("");
      setCityName("");
    }
  }, [countryCode]);

  useEffect(() => {
    if (stateCode && countryCode) {
      getCities(countryCode, stateCode);
    } else {
      setCityName("");
    }
  }, [stateCode, countryCode]);

  useEffect(() => {
    if (typeof onChange === "function") {
      onChange({
        country_code: countryCode,
        country: countryName,
        state_code: stateCode,
        state: stateName,
        city: cityName,
        search: searchText,
      });
    }
  }, [countryCode, countryName, stateCode, stateName, cityName, searchText]);

  const handleCountryChange = (option) => {
    setCountryCode(option?.value ?? null);
    setCountryName(option?.label ?? "");
  };

  const handleStateChange = (option) => {
    setStateCode(option?.value ?? null);
    setStateName(option?.label ?? "");
  };

  const handleCityChange = (option) => {
    setCityName(option?.label ?? "");
  };

  return (
    <div className="row g-2 address-filter bg-white shadow py-3">
      <div className="col-12 col-md-3 mt-0">
        {Array.isArray(filteredCountries) ? (
          <SearchSelect
            itemText="name"
            itemValue="iso2"
            items={filteredCountries}
            value={countryCode}
            modifier={handleCountryChange}
            placeholderText={placeholderCountry || "Seleccionar país"}
            controlBorder="1px solid #dee2e6"
            controlBorderRadius="100px"
          />
        ) : (
          <div className="spinner-border spinner-border-sm" role="status" />
        )}
      </div>
      <div className="col-12 col-md-3 mt-0">
        {Array.isArray(states) ? (
          <SearchSelect
            itemText="name"
            itemValue="iso2"
            items={states}
            value={stateCode}
            modifier={handleStateChange}
            placeholderText={placeholderState || "Seleccionar estado"}
            controlBorder="1px solid #dee2e6"
            controlBorderRadius="100px"
          />
        ) : countryCode ? (
          <div className="spinner-border spinner-border-sm" role="status" />
        ) : (
          <input
            type="text"
            className="form-control"
            placeholder={placeholderState || "Seleccionar estado"}
            disabled
            style={{ backgroundColor: "#ffffff", border: "1px solid #ced4da" }}
          />
        )}
      </div>
      <div className="col-12 col-md-3 mt-0">
        {Array.isArray(cities) ? (
          <SearchSelect
            itemText="name"
            itemValue="name"
            items={cities}
            value={cityName}
            modifier={handleCityChange}
            placeholderText={placeholderCity || "Seleccionar ciudad"}
            controlBorder="1px solid #dee2e6"
            controlBorderRadius="100px"
          />
        ) : stateCode ? (
          <div className="spinner-border spinner-border-sm" role="status" />
        ) : (
          <input
            type="text"
            className="form-control"
            placeholder={placeholderCity || "Seleccionar ciudad"}
            disabled
            style={{ backgroundColor: "#ffffff", border: "1px solid #ced4da" }}
          />
        )}
      </div>
      <div className="col-12 col-md-3 mt-0">
        <input
          type="text"
          id="filter-search"
          className="form-control"
          placeholder={placeholderSearch || "Buscar..."}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ backgroundColor: "#ffffff", border: "1px solid #ced4da" }}
        />
      </div>
    </div>
  );
};

export default AddressFilter;
